import {Concept} from 'types';
import type {
  AgentName,
  NationalAgent,
  NationalAgentType,
} from 'services/agent/types';
import {isFeatureEnabled} from 'configuration';
import {splitPersonName} from './splitPersonName';

const createSuggestedNameVariant = (
  agentType: NationalAgentType,
  suggestion: string,
): AgentName =>
  agentType === Concept.person && isFeatureEnabled('splitAgentName')
    ? splitPersonName(suggestion)
    : {name: suggestion};

export const createEmptyNationalAgent = (
  agentType: NationalAgentType,
  suggestion?: string,
): NationalAgent => {
  const suggestedNameVariant: AgentName[] | undefined = suggestion
    ? [createSuggestedNameVariant(agentType, suggestion)]
    : undefined;

  return {agentType, nameVariants: suggestedNameVariant} as NationalAgent;
};
